"use client"

// No se necesita 'useState' ya que no hay interacción del usuario para cambiar el slide.
// Si quisieras añadir flechas de navegación en el futuro, volverías a necesitarlo.
import { useState } from "react"

// Importa el nuevo archivo CSS
import "./css/inicio3.css"

// Rutas a las imágenes en la carpeta public/img/
const images = [
  { src: `${process.env.PUBLIC_URL}/img/portada9.jpg`, alt: "Slide 1" },
]

const Inicio3 = () => {
  // Aunque no hay controles, mantenemos la lógica por si se quiere mostrar un slide específico por defecto.
  const [currentSlide, setCurrentSlide] = useState(0)

  return (
    <section className="slider-container-v3" id="Inicio3">
      <div className="slider-wrapper-v3">
        <div className="slider-track-v3" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {images.map((image, index) => (
            <div key={index} className="slide-v3">
              <img
                src={image.src || `${process.env.PUBLIC_URL}/placeholder.svg`}
                alt={image.alt}
                className="slide-image-v3"
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src = `${process.env.PUBLIC_URL}/placeholder.svg?width=1200&height=700&text=Error+loading+${image.alt}`
                }}
              />
            </div>
          ))}
        </div>
        {/* El código de los indicadores ha sido eliminado completamente de aquí */}
      </div>
    </section>
  )
}

export default Inicio3
